module.exports = (s) => {
  return {
    rule_name: {
      label: '规则名称',
      type: 'input',
      props: {
        maxlength: 20,
        showWordLimit: true,
        placeholder: '请输入预警配置规则名称',
      },
      value: '',
      rules: { required: true, message: '请输入规则名称', trigger: ['change'] },
    },
    channel_type1_list: {
      label: '渠道类型',
      type: 'select',
      props: {
        multiple: true,
        filterable: true,
      },
      options: [],
      value: [],
      rules: { required: true, message: '请选择渠道类型', trigger: ['change'] },
    },
    channel_type2_list: {
      label: '渠道子类型',
      type: 'select',
      props: {
        multiple: true,
        filterable: true,
      },
      options: [],
      value: [],
    },
    game_id_list: {
      label: '游戏',
      type: 'select-tree',
      props: {
        checkStrictly: false,
        options: [],
        'select-props': {
          placeholder: '请选择',
          size: 'mini',
          clearable: true,
        },
      },
      value: null,
    },
    status: {
      label: '状态',
      type: 'radio-group',
      isButton: true,
      options: [
        { label: '启用', value: 1 },
        { label: '停用', value: 2 },
      ],
      value: 1,
    },
    rules: {
      label: '触发条件',
      value: [
        {
          cost: 1000,
          condition_type: 1, // 注册数
          condition_value: 1,
        },
        {
          cost: 1000,
          condition_type: 2, // 创角数
          condition_value: 1,
        },
        {
          cost: 20000,
          condition_type: 3, // 付费人数
          condition_value: 1,
        },
      ],
    },
    execution_frequency: {
      label: '执行频率',
      type: 'radio-group',
      isButton: true,
      is_filter: true,
      options: [
        { label: '30分钟', value: 1 },
      ],
      value: 1,
    },
    execution_action: {
      label: '执行动作',
      type: 'radio-group',
      isButton: true,
      is_filter: true,
      options: [
        { label: '发送通知', value: 1 },
      ],
      value: 1,
    },
    notification_method: {
      label: '通知方式',
      type: 'radio-group',
      isButton: true,
      is_filter: true,
      options: [
        { label: '企业微信群', value: 1 },
      ],
      value: 1,
    },
  };
};
